import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { MenusPage } from '@/features/menu/list-page';

/** Presentation guard; the API independently enforces menus:read/write on every request. */
export const Route = createFileRoute('/_authenticated/system/menus')({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'menus:read'),
  component: MenusPage,
});
